import { call, put } from "redux-saga/effects";

import {
    getFileTypeFailure,
    getFileTypeSuccess,
    getReseFileuploadLogsSuccess,
    getReseFileuploadLogsFailure,
    getReseCustomFileNameSuccess,
    getReseCustomFileNameError,
    getReseDriverConfigFileContentSuccess,
    getReseDriverConfigFileContentError,
    
} from "../components/rese/rese-file-upload/redux/actions";
import { getReseUserTableStoreSuccess, getReseUserTableStoreError} from "../components/rese/rese-users/redux/actions";

import ReseFileuploadService, {getReseCustomFileNameDistinctData, getDriverConfigFileContent} from "../components/rese/rese-file-upload/ReseFileuploadService";
import { getReseUserTableDistinctColumnData} from "../components/rese/rese-users/ReseUserService";

const fileUploadService = new ReseFileuploadService();


/**
 * Worker saga for loading file types
 */
function* loadFileTypes() {
    try {
        const fileTypeList = yield call(
            fileUploadService.getFileTypes
        );
        yield put(getFileTypeSuccess(fileTypeList.data));
    } catch (error) {
        yield put(getFileTypeFailure(error.toString()));
    }
}

function* loadFileUploadLogs() {
    try {
        const uploadLogs = yield call(
            fileUploadService.getReseFileuploadLogs
        );
        yield put(getReseFileuploadLogsSuccess(uploadLogs.data));
    } catch (error) {
        yield put(getReseFileuploadLogsFailure(error.toString()));
    }
}
export function* loadReseCustomFileNameDistinctColumnData ({customFileNamePayload}) {
    try {
        const reseCustomFileNameData = yield call(getReseCustomFileNameDistinctData, customFileNamePayload);
        yield put(getReseCustomFileNameSuccess(reseCustomFileNameData.data));
    } catch (error) {
        yield put(getReseCustomFileNameError(error.toString()));
    }
}
export function* loadDriverConfigFileContent ({selectedFileTypeName,store,driverConfigFileType}) {
    try {
        const reseDriverConfigFileContent = yield call(getDriverConfigFileContent,selectedFileTypeName,store,driverConfigFileType);
        yield put(getReseDriverConfigFileContentSuccess(reseDriverConfigFileContent));
    } catch (error) {
        yield put(getReseDriverConfigFileContentError(error.toString()));
    }
}
export function* loadReseUserTableStoreData ({storeColumnPayload}) {
    try {
        const storeData = yield call(getReseUserTableDistinctColumnData, storeColumnPayload);
        yield put(getReseUserTableStoreSuccess(storeData));
    } catch (error) {
        yield put(getReseUserTableStoreError(error.toString()));
    }
}
export { loadFileTypes, loadFileUploadLogs };
